import React, { Component } from "react";
import { Link } from "react-router-dom";

import "./../../public/scss/feedComponent.scss";

// import { sendLoginCredentials, getParetQuestions, submitFormNow } from './../actions/formActions';
import { connect } from 'react-redux';
// import { getUserData, logOut } from './../actions/utility';


import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  Button,
  Container,
  Row,
  Media,
  Col,
  Progress,
  Spinner,
  Alert,
  DropdownItem,
  DropdownToggle,
  Dropdown,
  DropdownMenu
  // NavLink
} from "reactstrap";

class NotificationsComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
        assignedNotifications : this.props.notifications,
        sortedNotifications : '',
    };

  }

  componentWillReceiveProps(nextProps, thisProps) {

  }

  
  componentDidMount() {
      console.log(this.state.assignedNotifications);      
  }

  componentWillUnmount() {
    
  }


  render() {

    const { assignedNotifications } = this.state;

    var sortedNotifications = assignedNotifications;
    sortedNotifications.sort(function(x, y){
      return x.notify_from_ts - y.notify_from_ts;
    });

    // var currentTimeStamp = new Date().getTime(); // gets current timestamp


    return (
        <div className="allNotifications">
            
            {
                sortedNotifications && sortedNotifications.length ?
                    <Col style={{paddingTop: '20px'}} md={{size: 12}}>
                        {

                          sortedNotifications.map((notification, key) => {
                            
                            var isStartTimeActive = new Date(parseInt(notification.notify_from_ts)).getTime() < new Date().getTime();
                            
                            var isEndTimeActive = new Date(parseInt(notification.notify_till_ts)).getTime() > new Date().getTime();
                            
                            // if current time is ahead of start time of notification
                            if(isStartTimeActive){

                              // if is always active that will remain there all the time.
                              if(notification.is_always == 0) {
                                if(!isEndTimeActive) {
                                  return false;
                                }
                              }

                              return (
                                <Alert key={key} color="warning" className="notificationAlert">
                                  <h4>{notification.notification_title}</h4>
                                  <div dangerouslySetInnerHTML={{__html: notification.notification_desc}}></div>
                                </Alert>
                              )
                            }
                          }).reverse()

                        }
                    </Col>
                : null
            }

        </div>
    );
  }
}

NotificationsComponent.propTypes = {
  // sendLoginCredentials: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  // loginResponse: state.feedRed.loginResponse,
})

export default connect(mapStateToProps, {  })(NotificationsComponent);
